// extracted by mini-css-extract-plugin
export default {"cancel_button":"Modals_cancel_button__1UPWe"};